import React, { useState, useEffect, Fragment } from "react";
import * as yup from "yup";
import { useFormik } from "formik";
import {
  Grid,
  Typography,
  Button,
  Hidden,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Menu,
  MenuItem,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useParams, useHistory } from "react-router-dom";
import {
  makeStyles,
  MuiThemeProvider,
  createMuiTheme,
} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import PropTypes from "prop-types";
import MUIDataTable from "mui-datatables";
import { Skeleton } from "@material-ui/lab";
import moment from "moment";
import io from "socket.io-client";

// Custom components
import UserDialog from "../components/users/UserDialog";
import SnackbarMessage from "../components/SnackbarMessage";
import NavigationTabs from "../components/NavigationTabs";
import ImportUsersModal from "../components/users/ImportUsersModal";
import ModifyDivisionsUsersDialog from "../components/users/ModifyDivisionsUsersDialog";
import PointSchedulerDialog from "../components/PointSchedulerDialog";
import LinearProgressWithLabel from "../components/global/LinearProgressWithLabel";

// API
import { getDivisionCategories } from "../api/Clients";
import { listRoles } from "../api/Roles";
import {
  createUser,
  updateUser,
  deleteUser,
  ModifyUsersByIds,
  createExportUsersQueue,
  getAllUsersForTableView,
  getEmailQueue,
  getImportEmailQueue,
  markAsViewed,
} from "../api/Users";
import { getUserPoints, createUserPoints } from "../api/Points";
import { listApprovalGroups } from "../api/ApprovalGroups";

// Styles needed for responsiveness
const useStyles = makeStyles((theme) => ({
  mainContainer: {
    [theme.breakpoints.up("lg")]: {
      paddingLeft: "190px",
    },
  },
  modifyopenbutton: {
    [theme.breakpoints.up("md")]: {
      //float: "right",
      marginLeft: "10px",
    },
  },
  SelectButton: {
    float: "right",
  },
  SelectButtonCancel: {
    [theme.breakpoints.up("md")]: {
      float: "right",
    },
    [theme.breakpoints.down("md")]: {
      marginLeft: "10px",
    },
  },
}));

// We need use forwardRef in order to expose ref to getUsers for data refreshing
const UserList = (props) => {
  const classes = useStyles();
  //check if url contains client_id
  let { client_id } = useParams();
  const [division_categories, setDivisionCategories] = useState([]);
  const [approval_groups, setApprovalGroups] = useState([]);
  const [user_division_categories, setUserDivisionCategories] = useState([]);
  const [roles, setRoles] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [edit, setEdit] = React.useState(false);
  const [userList, setUserList] = useState([]);
  const [fromClient] = React.useState(client_id ? true : false);
  const [OpenUserimport, setUserimport] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [isCustomer, setCustomer] = useState(false);
  const history = useHistory();
  const [exportUserOpen, setExportUserOpen] = useState(false);
  const [Select, setSelect] = useState(false);
  const [openModifyDialog, setOpenModifyDialog] = useState(false);
  const [ModifyDivisions, setModifyDivisions] = useState(false);
  const [loadingDivisions, setloadingDivisions] = useState(true);
  const [clientUsers, setClentUsers] = useState([]);
  const currentClient = props.clients.find((client) => client.id == client_id);
  const [usersToModify, setUsersToModify] = useState([]);
  const [selectedUsersIndex, setSelectedUsersindex] = useState([]);
  const [filterUsers, setFilterUsers] = useState([]);
  const [columnViewPorcentage, setColumViewPorcentage] = useState(100 / 6);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // Steps for email queue
  const emailQueueSteps = [
    "Request received", // null
    "Request in process queue", // queued
    "Processing request", // processing
    "Done. Check your email", // done
  ];
  const [activeStep, setActiveStep] = useState(0);
  const [emailQueue, setEmailQueue] = useState(null);
  const [progress, setProgress] = React.useState(0);
  // Steps for the import email queue (same wording pattern as export, per AV-1062)
  const importQueueSteps = [
    "Request received", // null
    "Request in process queue", // queued
    "Processing request", // processing
    "Done. Check your users list", // done
  ];
  const [importActiveStep, setImportActiveStep] = useState(0);
  const [importQueue, setImportQueue] = useState(null);
  const [importProgress, setImportProgress] = React.useState(0);
  const [contextMenu, setContextMenu] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  // Initial form data
  const initial_user = {
    id: null,
    first_name: "",
    last_name: "",
    username: "",
    password: "",
    email: "",
    billing_department: "",
    site: "",
    confirmed: false,
    division_categories: [],
    role: "",
    group_ids: currentClient?.mode === "Approval" ? "" : 0,
    hireDate: null,
    Employee_ID: "",
  };

  // Open user dialog
  const handleClickOpen = (user) => {
    setEdit(false);
    //set user points
    let divisionCategories = [];
    division_categories.forEach((category) => {
      let currentCategory = {
        id: category.id,
        name: category.Name,
        balance: 0,
        original_balance: 0,
        checked: false,
        transaction_amount: 0,
      };
      divisionCategories.push(currentCategory);
    });
    if (!user) {
      setUserDivisionCategories([]);
      resetUserForm(initial_user, divisionCategories, user_division_categories);
      setOpen(true);
    } else if (user) {
      // We are editing user
      setEdit(true);

      // Set user form values
      let open_user_division_categories = user.division_categories.map((dc) => {
        return dc.id;
      });
      setUserDivisionCategories(open_user_division_categories);

      if (user_division_categories.length == 0) {
        resetUserForm(user, divisionCategories, user_division_categories);
        setOpen(true);
      } else {
        //get user balance for current division categories
        getUserPoints(user.id).then((res) => {
          if (res.data.userPoints && res.data.userPoints.length) {
            res.data.userPoints.forEach((division) => {
              //check the array of client divisions
              for (let index = 0; index < divisionCategories.length; index++) {
                if (
                  division.division_category_id == divisionCategories[index].id
                )
                  divisionCategories[index] = {
                    id: division.division_category_id,
                    balance:
                      division.points_balance != null
                        ? division.points_balance
                        : 0,
                    original_balance:
                      division.points_balance != null
                        ? division.points_balance
                        : 0,
                    transaction_amount: 0,
                    checked: false,
                    name: division.DivisionName,
                  };
              }
            });
          }
          resetUserForm(user, divisionCategories, user_division_categories);
          setOpen(true);
        });
      }
    }
  };

  const resetUserForm = (
    user,
    divisionCategories,
    user_division_categories
  ) => {
    formik.resetForm({
      values: {
        id: user.id,
        first_name: user.Details
          ? user.Details.FirstName
            ? user.Details.FirstName
            : ""
          : "",
        last_name: user.Details
          ? user.Details.LastName
            ? user.Details.LastName
            : ""
          : "",
        username: user.username,
        password: "",
        email: user.email,
        billing_department: user.Details
          ? user.Details.BillingDepartment
            ? user.Details.BillingDepartment
            : ""
          : "",
        site: user.Details ? (user.Details.Site ? user.Details.Site : "") : "",
        confirmed: user.confirmed,
        division_categories: divisionCategories,
        user_division_categories: user_division_categories,
        role: user.role.id,
        group_ids: user.group_ids,
        hireDate: user.hireDate || null,
        Employee_ID: user.Employee_ID || "",
      },
    });
  };

  //Open Import user modal
  const ShowimporUser = () => {
    setUserimport(true);
  };

  // Close user dialog
  const handleClose = () => {
    setCustomer(false);
    setOpen(false);
    setUserimport(false);
    setOpenModifyDialog(false);
    setModifyDivisions(false);
    formik.resetForm({
      values: initial_user,
    });
    setContextMenu(null);
    setSelectedRow(null);
  };

  // Manage errors
  const [error, setError] = useState({
    message: "",
    severity: "info",
    open: false,
  });

  // Close snackbar
  const handleCloseSnackbar = () => {
    setError({
      open: false,
      message: "",
      severity: "info",
    });
  };

  // Get user entries
  const getUsers = ({ silent = false } = {}) => {
    // Skip the loading skeleton for silent (background) refreshes, e.g. those
    // triggered by importProgress, so the table doesn't flash on every batch
    if (!silent) setLoading(true);
    const filterClientId = fromClient && client_id ? client_id : null;
    const filterResellerId = filterClientId
      ? null
      : localStorage.getItem("reseller_id");
    // Get all users for table view
    getAllUsersForTableView(filterClientId, filterResellerId)
      .then((result) => {
        if (result && result.data && result.data.getUsersTable) {
          // Set user list
          const users = result.data.getUsersTable;
          setUserList(users);
          setClentUsers(users);
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        if (!silent) setLoading(false); // set loading to false
      });
  };

  // Debounce silent table refetches triggered by importProgress events, so a
  // burst of batches (10 rows each) doesn't hammer getUsersTable
  const silentUsersRefreshTimeoutRef = React.useRef(null);
  const scheduleSilentUsersRefresh = () => {
    if (silentUsersRefreshTimeoutRef.current) {
      clearTimeout(silentUsersRefreshTimeoutRef.current);
    }
    silentUsersRefreshTimeoutRef.current = setTimeout(() => {
      getUsers({ silent: true });
    }, 1000);
  };

  // Delete single user
  const removeUser = (id) => {
    setSaving(true);
    deleteUser(id)
      .then((result) => {
        setSaving(false);
        if (result.errors) {
          setError({
            open: true,
            message: `Error: ${result.errors[0].message}`,
            severity: "error",
          });
          localStorage.removeItem("userViewTable");
          localStorage.removeItem("currentUserPage");
          localStorage.removeItem("currentUserRows");
        } else {
          getUsers();
          handleClose();
          setError({
            open: true,
            message: "User Deleted Successfully",
            severity: "success",
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  // List users at the first time and when client_id changes
  useEffect(() => {
    // Get users
    getUsers();
    setUsersToModify([]);
    // Get email queue status
    if (client_id) {
      getEmailQueueStatus();
      getImportEmailQueueStatus();
    }
  }, [client_id]);

  // List division categories, approval groups & roles at the first load
  useEffect(() => {
    // List division categories
    if (client_id && client_id != 0) {
      // List division categories
      getDivisionCategories({ client_id })
        .then((result) => {
          setDivisionCategories(result);
          setloadingDivisions(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }
    // List approval groups
    getApprovalGroups();
    // List roles
    listRoles()
      .then((result) => {
        let role = localStorage.getItem("role");
        let roles = result.data.roles;
        let filter_roles = [];
        switch (role) {
          case "clientusermanager":
            for (let i = 0; i < roles.length; i++) {
              if (
                (roles[i] && roles[i].id == 3) ||
                roles[i].id == 4 ||
                roles[i].id == 7
              ) {
                filter_roles.push(roles[i]);
              }
            }
            setRoles(filter_roles);
            break;
          case "superadmin":
            if (fromClient) {
              for (let i = 0; i < roles.length; i++) {
                if (roles[i].id != 8 && roles[i].id != 6) {
                  filter_roles.push(roles[i]);
                }
              }
              setRoles(filter_roles);
            } else {
              setRoles(result.data.roles);
            }
            break;
          case "clientorderapprover":
            for (let k = 0; k < roles.length; k++) {
              if (
                (roles[k] && roles[k].id == 4) ||
                roles[k].id == 7 ||
                roles[k].id == 5
              ) {
                filter_roles.push(roles[k]);
              }
            }
            break;
          case "reselleradmin":
            for (let i = 0; i < roles.length; i++) {
              if (fromClient) {
                if (roles[i] && roles[i].id != 6 && roles[i].id != 8) {
                  filter_roles.push(roles[i]);
                }
              } else {
                if (roles[i] && roles[i].id != 6) {
                  filter_roles.push(roles[i]);
                }
              }
            }
            setRoles(filter_roles);
            break;
          case "clientadmin":
            for (let i = 0; i < roles.length; i++) {
              if (
                (roles[i] && roles[i].id == 9) ||
                roles[i].id == 3 ||
                roles[i].id == 4 ||
                roles[i].id == 5 ||
                roles[i].id == 7
              ) {
                filter_roles.push(roles[i]);
              }
            }
            setRoles(filter_roles);
            break;
          case "clientproductmanager":
            for (let i = 0; i < roles.length; i++) {
              if (
                (roles[i] && roles[i].id == 5) ||
                roles[i].id == 7 ||
                roles[i].id == 3 ||
                roles[i].id == 4
              ) {
                filter_roles.push(roles[i]);
              }
            }
            setRoles(filter_roles);
            break;
          default:
            break;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  /**
   * Get approval groups
   */
  const getApprovalGroups = async (loadGroupId = false) => {
    await listApprovalGroups(client_id)
      .then((result) => {
        const approvalGroups = result.data.approvalGroups || [];
        if (approvalGroups.length) {
          setApprovalGroups(result.data.approvalGroups);
          if (loadGroupId) {
            formik.setFieldValue("group_ids", approvalGroups[0].id);
          }
        } else {
          console.log("Error listing approval groups", error);
        }
      })
      .catch((error) => {
        console.log("Error listing approval groups", error);
      });
  };

  /**
   * Formik validation schema
   */
  const validationSchema = yup.object({
    first_name: yup.string("First Name").required("First name is required"),
    last_name: yup.string("Last Name").required("Last name is required"),
    username: yup.string("Username").required("Username is required"),
    password:
      edit || isCustomer
        ? yup
            .string("Password")
            .min(8, "Password must contain at least 8 characteres")
        : yup
            .string("Password")
            .required("Password is required")
            .min(8, "Password must contain at least 8 characteres"),
    email: yup.string("Email").required("Email is required"),
    billing_department: yup.string("Billing Department"),
    site: yup.string("Site"),
    confirmed: yup.bool(),
    division_categories: yup
      .array()
      .typeError("Division Categories must be an array"),
    role: edit
      ? yup.number().typeError("Role must be a number")
      : yup
          .number()
          .required("Role is required")
          .typeError("Role must be an number"),
    group_ids: yup
      .number()
      .typeError("Approval Groups must be a number")
      .when("role", {
        is: (role) => role === 7 && currentClient?.mode === "Approval",
        then: yup
          .number()
          .required("Group approval group is required for customers"),
        otherwise: yup.number(),
      }),
    hireDate: yup.date("Hire Date").nullable(),
    Employee_ID: yup.string("Employee ID").required("Employee ID is required"),
  });

  // Manage form data
  const formik = useFormik({
    initialValues: initial_user,
    validationSchema: validationSchema,
    onSubmit: (original_values) => {
      let values = { ...original_values };
      setSaving(true);
      //check if the user has the client's division categories.
      values.user_division_categories = user_division_categories;
      // Removing spaces from the user
      const properties = ["first_name", "last_name", "username"];
      for (const property of properties) {
        if (`${property}` in values) {
          values[property] = values[property].trim();
        }
      }
      //Customer
      if (isCustomer && values.role == 7) {
        // If no pass provided, set default one
        if (values.password === "") {
          values.password = "uHFLoLmlcqg1&y!KhbnQW9LIoI*a9w3O";
        }
        //If not a test user.
        if (fromClient) {
          //get the client domain and add it automatically to the username
          values.username = currentClient.subdomain + "-" + values.username;
        }

        if (client_id && client_id != 0) {
          values.clients = [client_id];
        }
      }
      // Relate to client if it is selected
      if (client_id && client_id != 0) {
        values.clients = [client_id];
      }
      // Validate hire date
      if (values.hireDate) {
        values.hireDate = moment(values.hireDate).format("YYYY-MM-DD");
      }
      (values.id == null ? createUser(values, fromClient) : updateUser(values))
        .then((res) => {
          let resp_prop_name = values.id == null ? "createUser" : "updateUser";
          if (
            "data" in res &&
            resp_prop_name in res.data &&
            res.data[resp_prop_name] &&
            res.data[resp_prop_name].user
          ) {
            localStorage.removeItem("userViewTable");
            localStorage.removeItem("currentUserPage");
            localStorage.removeItem("currentUserRows");
            // Save points changes
            // Check every category to see if there are changes in points, then create a new record for each one
            // First, check if the user divison categories array contains category
            const userDivisionCategoriesPoints = values.division_categories
              .filter(
                (category) =>
                  user_division_categories.includes(category.id) &&
                  category.balance != category.original_balance
              )
              .map((cat) => ({
                id: cat.id,
                balance: cat.balance,
              }));
            // Create points
            createUserPoints(
              values.id ? values.id : res.data.createUser.user.id,
              userDivisionCategoriesPoints
            )
              .then((res) => {
                // Display success message
                if (res?.data?.createUserPoints) {
                  setError({
                    open: true,
                    message: "Points Added Successfully",
                    severity: "success",
                  });
                }
              })
              .catch((error) => console.log("Error:", error));
            getUsers();
            handleClose();
            setError({
              open: true,
              message:
                "User " +
                (values.id == null ? "Created" : "Updated") +
                " Successfully",
              severity: "success",
            });
            formik.resetForm();
          } else {
            // Display error
            let error_message =
              "errors" in res &&
              Array.isArray(res.errors) &&
              res.errors.length > 0 &&
              "message" in res.errors[0]
                ? res.errors[0].message
                : `An error occurred, please try again`;
            setError({
              open: true,
              message: error_message,
              severity: "error",
            });
          }
        })
        .catch((res) => {
          // Display error
          let error_message =
            "errors" in res &&
            Array.isArray(res.errors) &&
            res.errors.length > 0 &&
            "message" in res.errors[0]
              ? res.errors[0].message
              : `An error occurred, please try again`;
          setError({
            open: true,
            message: error_message,
            severity: "error",
          });
        })
        .then(function () {
          setSaving(false);
        });
    },
  });

  const addDivisionCategory = (value) => {
    let open_user_division_categories = [...user_division_categories];
    let flag = false;
    for (let i = 0; i < open_user_division_categories.length; i++) {
      if (open_user_division_categories[i] == value.id) {
        flag = true;
      }
    }
    if (!flag) {
      open_user_division_categories.push(value.id);
    }
    setUserDivisionCategories(open_user_division_categories);
  };

  const removeDivisionCategory = (value) => {
    let open_user_division_categories = [...user_division_categories];
    let index = false;
    for (let i = 0; i < open_user_division_categories.length; i++) {
      if (open_user_division_categories[i] == value.id) {
        index = i;
      }
    }
    open_user_division_categories.splice(index, 1);
    value.balance = 0;
    setUserDivisionCategories(open_user_division_categories);
  };

  /**
   * Create export users queue
   * @param {Int} client_id 'ID' Field in the client's content type
   */
  const createUserExportQueue = async (client_id) => {
    // Validate client id
    if (client_id && client_id != 0) {
      // Fail fast with the same tooltip-style reason instead of round-tripping
      // to the backend guard — the backend's beforeCreate hook (AV-1062 CA-03)
      // is still the authoritative check, this is just a cheap UX shortcut
      // using whatever state is already in memory.
      if (isQueueRunning(importQueue)) {
        setError({
          open: true,
          message: "Wait for the current import to finish.",
          severity: "error",
        });
        setExportUserOpen(false);
        syncQueueStatuses();
        return;
      }
      // The user just accepted the confirmation dialog — this is the actual
      // commitment to start an export, so it's the right moment (not when the
      // dialog was merely opened) to clear any finished bar left on screen
      dismissFinishedQueues();
      // Create export users queue
      createExportUsersQueue(client_id, filterUsers)
        .then(async (result) => {
          // Get email queue id
          const emailQueueId =
            result?.data?.createEmailQueue?.emailQueue?.id || null;
          // Validate email queue id
          if (emailQueueId) {
            // Set success message
            setError({
              open: true,
              message: `Users export queue Created Successfully`,
              severity: "success",
            });
            // Get email queue status
            getEmailQueueStatus();
          } else {
            // A GraphQL resolver error (e.g. the backend's mutual-exclusion
            // guard) lands here with the real reason in result.errors — show
            // it instead of a generic message, and re-sync state so this tab
            // immediately reflects whichever queue actually blocked it.
            setError({
              open: true,
              message:
                result?.errors?.[0]?.message ||
                `An error occurred, please try again`,
              severity: "error",
            });
            syncQueueStatuses();
          }
        })
        .catch(() => {})
        .finally(() => setExportUserOpen(false));
    }
  };

  // Open Export users dialog
  const handleClickOpenExportUserModal = () => {
    const value = exportUserOpen ? false : true;
    setExportUserOpen(value);
  };

  // Export users modal/dialog :/
  const ExportUsersModal = (props) => {
    const { open, handleClose /*, UserToExport , getAllUsers*/ } = props;
    return (
      <div>
        <Dialog
          id="usersexport_dialog"
          open={open}
          onClose={handleClose}
          aria-labelledby="Cnfirmation_import_users"
          aria-describedby="alert-dialog-description"
          fullWidth
          maxWidth={"sm"}
        >
          <DialogTitle id="alert-dialog-title">{"Export Users"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Grid>
                <Typography gutterBottom>
                  All client users will be exported to a CSV file and sent by
                  email later. Do you want to continue?
                </Typography>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Grid item xs={5} md={6} lg={7} />
            <Grid item xs={7} md={6} lg={5}>
              <Grid container spacing={2}>
                <Grid item xs={5} sm={6} md={5} lg={5}>
                  <Button onClick={handleClose} variant="contained" fullWidth>
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={7} sm={6} md={7} lg={7}>
                  <Button
                    type="submit"
                    onClick={() => {
                      createUserExportQueue(client_id);
                    }}
                    color="primary"
                    autoFocus
                    variant="contained"
                    fullWidth
                  >
                    Continue
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </DialogActions>
        </Dialog>
      </div>
    );
  };

  // propTypes
  ExportUsersModal.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    client_id: PropTypes.string,
  };

  const DisableUsers = () => {
    let users = usersToModify;
    if (users.length > 0) {
      let value = { confirmed: false, users: users, action: "disable" };
      ModifyUsersByIds(value)
        .then((result) => {
          if (result.length > 0) {
            setUsersToModify([]);
            getUsers();
            setError({
              open: true,
              message: "Users Disabled Successfully",
              severity: "success",
            });
          } else {
            setError({
              open: true,
              message: `An error occurred, please try again`,
              severity: "error",
            });
          }
        })
        .catch((error) => {
          console.log("Error:", error);
        })
        .finally(() => {
          setSelect(false);
          setUsersToModify([]);
        });
    }
  };

  //Modufy user Dialog to small screens
  const ModufyDialog = (props) => {
    const { open, handleClose, usersToModify = [], DisableUsers } = props;
    return (
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Disable multiple users"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {usersToModify.length > 0
              ? "Multple users will be disabled. Do you want to continue?"
              : "You have not selected any user to disable, select some to continue"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained" color="default">
            CANCEL
          </Button>
          <Button
            onClick={() => {
              DisableUsers();
              handleClose();
            }}
            variant="contained"
            color="secondary"
            autoFocus
            disabled={usersToModify.length > 0 ? false : true}
          >
            DISABLE USERS
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  ModufyDialog.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func,
    usersToModify: PropTypes.array,
    DisableUsers: PropTypes.func,
  };

  // Open alert dialog - users disable
  const HandleOpenModifyDialog = () => {
    setOpenModifyDialog(true);
  };

  // Open modify division users
  const handleModifyUsers = () => {
    setModifyDivisions(true);
  };

  // Custom styles for text column
  const customStyle = ({ ...column }) => {
    return (
      <div
        className={classes.ListItem}
        style={{
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          overflow: "hidden",
          fontWeight: "bold",
          padding: "10px",
          height: "10px",
          width: "100%",
        }}
      >
        {column.label}
      </div>
    );
  };
  // Custom style by columns
  const customStyleText = (value = "") => {
    // Validate user id
    let userId = null;
    if (value && value.startsWith('{"id":')) {
      const user = JSON.parse(value);
      // Get user name
      value = user.username || "-";
      userId = user.id || null;
    }
    value = value && value.length !== 0 ? value : "-";
    // Adding user id
    const key = userId ? { key: userId } : {};
    return (
      <div
        {...key}
        id={userId ? userId : `user-row-${new Date().toLocaleString()}`}
        style={{
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          overflow: "hidden",
        }}
      >
        {value}
      </div>
    );
  };

  // Websocket connection — reconnects only when the viewed client changes,
  // not on every status poll (emailQueue/importQueue always produce a fresh
  // object reference, which would otherwise tear down and recreate the
  // socket on nearly every fetch and risk dropping events during the gap)
  useEffect(() => {
    // Connect to the websocket
    const socket = io(process.env.REACT_APP_REST_URL, {
      query: { token: localStorage.getItem("token") },
      secure: true,
    });
    // Listen for status updates (shared by export and import email queue rows)
    socket.on("statusUpdate", (data) => {
      // Scoped by client, not by user: exclusivity is per-client, so any tab
      // viewing this client must reflect the active queue even if another
      // user is the one who started it.
      if (data.client_id == client_id) {
        // Get email queue status
        setTimeout(() => getEmailQueueStatus(), 1000);
        // Get import email queue status
        setTimeout(() => getImportEmailQueueStatus(), 1000);
      }
    });
    // Listen for granular import progress (processed/total per batch)
    socket.on("importProgress", (data) => {
      // Same per-client scoping as statusUpdate above.
      if (data.clientId == client_id) {
        // Refine the progress bar percentage within the "Processing" range
        if (data.total) {
          setImportProgress(
            50 + Math.round((data.processed / data.total) * 45)
          );
        }
        // Refresh the users table without flashing the loading skeleton
        scheduleSilentUsersRefresh();
      }
    });
    // Clean up: disconnect the socket when the component unmounts
    return () => {
      socket.disconnect();
      if (silentUsersRefreshTimeoutRef.current) {
        clearTimeout(silentUsersRefreshTimeoutRef.current);
      }
    };
  }, [client_id]);

  // Import/export are mutually exclusive: a button stays disabled only while
  // a queue (its own or the other one) is genuinely running (not yet DONE).
  // Once DONE, the buttons re-enable immediately — no click required — and
  // any leftover finished bar is auto-dismissed the moment the user starts
  // the next action (see dismissFinishedQueues below), so unviewed rows never
  // pile up even though the user was never forced to close it by hand.
  const isQueueRunning = (queue) => !!queue && queue.status !== "DONE";

  // Explains, in the disabled button's tooltip, why it can't be clicked yet
  const getBlockedReason = (queue, label) =>
    isQueueRunning(queue)
      ? `Wait for the current ${label.toLowerCase()} to finish`
      : "";

  // Manually dismiss the export status bar (also called automatically —
  // see dismissFinishedQueues — right before a new action starts)
  const handleDismissEmailQueue = () => {
    markAsViewed(emailQueue.id);
    setEmailQueue(null);
  };

  // Manually dismiss the import status bar
  const handleDismissImportQueue = () => {
    markAsViewed(importQueue.id);
    setImportQueue(null);
  };

  // Clears any status bar still sitting on screen after reaching DONE, so
  // starting a new action doesn't leave the previous result stranded
  // unviewed — saves the user an extra click on the "X" in the common case
  // where they just move on to the next action
  const dismissFinishedQueues = () => {
    if (emailQueue?.status === "DONE") handleDismissEmailQueue();
    if (importQueue?.status === "DONE") handleDismissImportQueue();
  };

  // Get email queue status
  const getEmailQueueStatus = () => {
    // Get email queue
    getEmailQueue(client_id).then((res) => {
      // Get email queue
      const emailQueue = res?.data?.emailQueues?.[0] || null;
      // Set email queue
      setEmailQueue(emailQueue);
      // Validate email queue
      if (emailQueue) {
        // Get email queue status
        const status = emailQueue.status;
        // Set active step
        switch (status) {
          case "QUEUED":
            setActiveStep(1);
            setProgress(50);
            break;
          case "PROCESSING":
            setActiveStep(2);
            setProgress(75);
            break;
          case "DONE":
            setActiveStep(3);
            setProgress(100);
            break;
          default:
            setActiveStep(0);
            setProgress(25);
            break;
        }
      }
    });
  };

  // Get import email queue status
  const getImportEmailQueueStatus = () => {
    // Get import email queue
    getImportEmailQueue(client_id).then((res) => {
      // Get import email queue
      const importQueue = res?.data?.emailQueues?.[0] || null;
      // Set import email queue
      setImportQueue(importQueue);
      // Validate import email queue
      if (importQueue) {
        // Get import email queue status
        const status = importQueue.status;
        // Recover the processed/total counters the backend persists per batch
        // (nested under options.progress), so a page reload mid-import restores
        // the real percentage instead of resetting to 0%
        let processedCount = null;
        let totalCount = null;
        try {
          const options =
            typeof importQueue.options === "string"
              ? JSON.parse(importQueue.options)
              : importQueue.options;
          processedCount = options?.progress?.processed ?? null;
          totalCount = options?.progress?.total ?? null;
        } catch (error) {
          // Ignore malformed/absent options, fall back to the fixed step percentage
        }
        // Set active step
        switch (status) {
          case "QUEUED":
            setImportActiveStep(1);
            setImportProgress(50);
            break;
          case "PROCESSING":
            setImportActiveStep(2);
            setImportProgress(
              totalCount
                ? 50 + Math.round((processedCount / totalCount) * 45)
                : 75
            );
            break;
          case "DONE":
            setImportActiveStep(3);
            setImportProgress(100);
            break;
          default:
            setImportActiveStep(0);
            setImportProgress(25);
            break;
        }
      }
    });
  };

  // Re-syncs both queue states from the backend — used when a create request
  // gets rejected by the backend's mutual-exclusion guard (AV-1062 CA-03), so
  // the tab that got rejected immediately shows the real bar/disabled buttons
  // for whichever queue (import or export) actually blocked it, instead of
  // just a toast, and without waiting on a reload or a delayed socket event.
  const syncQueueStatuses = () => {
    getEmailQueueStatus();
    getImportEmailQueueStatus();
  };

  // Mui Data table custom Stykes
  const theme = () =>
    createMuiTheme({
      overrides: {
        //Table head custom styles
        MUIDataTableHeadCell: {
          fixedHeader: {
            paddingTop: "0px",
            paddingBottom: "10px",
            backgroundColor: "#F2F2F2",
            borderRight: "1px solid #E5E3E3",
          },
        },
        // Search form custom style
        MUIDataTableSearch: {
          main: {
            visibility: true,
          },
        },
        // Chip filters custom styles
        MUIDataTableFilterList: {
          root: {
            marginBottom: "10px",
          },
        },
        // Filter container custom styles
        MuiGrid: {
          container: {
            display: "block",
            width: "210px",
            paddingLeft: "opx",
          },
          item: {
            boxSizing: "content-box",
          },
        },
        // Filter list options custom styles
        MUIDataTableFilter: {
          checkboxIcon: {
            padding: "0px",
          },
          checkboxFormControlLabel: {
            padding: "0px",
          },
          checkboxListTitle: {
            width: "100%",
          },
        },
        MUIDataTableSelectCell: {
          headerCell: {
            backgroundColor: "#F2F2F2",
          },
        },
        MUIDataTableToolbarSelect: {
          root: { visibility: "hidden", minHeight: "49px" },
        },
        MuiTableHead: {
          root: {
            display: `${columnViewPorcentage ? "table-header-group" : "none"}`,
          },
        },
        MuiTableBody: {
          root: {
            display: `${columnViewPorcentage ? "table-row-group" : "none"}`,
          },
        },
      },
    });

  const initialColums = [
    // Name column
    {
      name: "Name",
      label: "Name",
      options: {
        filter: false,
        setCellProps: () => {
          return {
            style: {
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            },
          };
        },
        customHeadLabelRender: customStyle,
        customBodyRender: (value) => customStyleText(value),
      },
    },
    // Username column
    {
      name: "Control_column",
      label: "Username",
      options: {
        filter: false,
        setCellProps: () => {
          return {
            style: {
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            },
          };
        },
        customHeadLabelRender: customStyle,
        customBodyRender: (value) => customStyleText(value),
      },
    },
    // Billing department column
    {
      name: "Billing_Department",
      label: "Billing Department",
      options: {
        filter: true,
        setCellProps: () => {
          return {
            style: {
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            },
          };
        },
        customHeadLabelRender: customStyle,
        customBodyRender: (value) => customStyleText(value),
      },
    },
    // Role column
    {
      name: "Role",
      label: "Role",
      options: {
        filter: true,
        setCellProps: () => {
          return {
            style: {
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            },
          };
        },
        customHeadLabelRender: customStyle,
        customBodyRender: (value) => customStyleText(value),
      },
    },
    // Status column
    {
      name: "Status",
      label: "Status",
      options: {
        filter: true,
        setCellProps: () => {
          return {
            style: {
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            },
          };
        },
        customHeadLabelRender: customStyle,
        customBodyRender: (value) => customStyleText(value),
      },
    },
    // Hire Date Column
    {
      name: "Hire_date",
      label: "Date of Hire",
      options: {
        filter: false,
        setCellProps: () => {
          return {
            style: {
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            },
          };
        },
        customHeadLabelRender: customStyle,
        customBodyRender: (value) => customStyleText(value),
      },
    },
  ];

  // Table options
  const options = {
    filter: true,
    filterType: "checkbox",
    sortFilterList: true,
    selectableRows: !fromClient ? false : "multiple",
    searchPlaceholder: "Search all users",
    textLabels: {
      body: {
        noMatch: "Sorry, no matching records found",
        toolTip: "Sort",
        columnHeaderTooltip: (column) => `${column.label}`,
      },
    },
    download: false,
    responsive: "standard",
    // TODO: Add onRowClick to redirect to user details page only if handleContextMenu is not working
    // onRowClick: (rowData) => {
    //   // Get user id
    //   const userId = rowData[1].key;
    //   // Redirect to user client view
    //   fromClient && userId
    //     ? history.push(`/app/client/${client_id}/user/${userId}`)
    //     : userId && history.push(`/app/user/${userId}`);
    // },
    elevation: 0,
    onRowSelectionChange(currentRowsSelected, allRowsSelected, rowsSelected) {
      // Gets the selected users in the table
      if (
        rowsSelected &&
        Array.isArray(rowsSelected) &&
        rowsSelected.length != 0
      ) {
        let users = [];
        for (const index of rowsSelected) {
          const user = clientUsers[index];
          if (user.Status == "Active") users.push(user);
        }
        setUsersToModify(users);
        if (users.length !== 0) setSelect(true);
      } else {
        setSelect(false);
        setUsersToModify([]);
      }
    },
    customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {
      // Validates the selected users
      let selectedIds = [];
      let allUsersIndex = [];
      for (const userIndex of selectedRows.data) {
        const index =
          userIndex && userIndex.index >= 0 ? userIndex.index : null;
        if (index >= 0) {
          const username = displayData[index].data[1].key;
          selectedIds.push(username);
          const user = clientUsers.find((user) => user.id == username);
          if (user && typeof user == "object" && user.Status == "Active") {
            allUsersIndex.push(index);
          }
        }
      }
      // Check if you meet the condition to be selected
      const canSelect = selectedIds.every(
        (username) =>
          clientUsers.find((item) => item.id === username)?.Status === "Active"
      );
      if (canSelect && allUsersIndex.length !== selectedUsersIndex.length) {
        setSelectedUsersindex(allUsersIndex);
        setSelectedRows(allUsersIndex);
      } else if (!canSelect) {
        setSelectedRows(allUsersIndex);
      }
    },
    onTableChange: (action, state) => {
      // Fitering by columns
      if (action == "filterChange") {
        const usersData =
          state && state.displayData && state.displayData.length > 0
            ? state.displayData
            : [];
        let filterUsers = [];
        for (const userData of usersData) {
          const username = userData.data[1].key;
          const user = clientUsers.find((user) => user.id == username);
          if (user && typeof user == "object") {
            filterUsers.push(user.id);
          }
        }
        clientUsers.length !== filterUsers.length
          ? setFilterUsers(filterUsers)
          : setFilterUsers([]);
      }
      // columns porcetage views
      if (action == "viewColumnsChange") {
        const columns = state.columns;
        let countColumns = columns.length;
        let showColumns = 0;
        for (const column of columns) {
          if (column.display == "true") {
            showColumns++;
          }
        }
        if (showColumns !== columns.length) {
          countColumns = showColumns;
        }
        const columnViewPorcentage =
          countColumns > 0 ? 100 / countColumns : null;
        setColumViewPorcentage(columnViewPorcentage);
      }
    },
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [10, 20, 50, 100],
    page: page,
    onChangePage: (currentPage) => {
      localStorage.setItem("currentUserPage", currentPage);
      setPage(currentPage);
    },
    onChangeRowsPerPage: (numberOfRows) => {
      localStorage.setItem("currentUserRows", numberOfRows);
      setRowsPerPage(numberOfRows);
      setPage(0);
    },
  };

  /**
   * Function to handle right click on table row
   * @param {MouseEvent} event - The mouse event object
   */
  const handleContextMenu = (event) => {
    // Find the closest table row
    const tr =
      event && event.target && event.target.closest
        ? event.target.closest("tr")
        : null;
    // Initialize index
    let index = fromClient ? 2 : 1; // Default index for non-client view
    // Validate if it's a client view
    if (fromClient) {
      // Search the closest td element
      const td = event.target instanceof Element ? event.target.closest("td") : null;
      // If the td is found, get the input checkbox
      if (td) {
        // Search for the checkbox input inside the td (it may be nested within several div/span)
        const checkbox = td.querySelector('input[type="checkbox"]');
        if (checkbox) {
          // If the checkbox was found, do not show the context menu
          return;
        }
      }
    }
    // Get the third column (index 2) of the row
    // Ensure tr exists and has enough cells
    if (!tr || !tr.querySelectorAll("td") || tr.querySelectorAll("td").length <= index) {
      return;
    }
    const cell = tr.querySelectorAll("td")[index];
    // Get the user id from the cell's div
    const userId = cell
      .querySelector("div")
      .querySelector("div")
      .getAttribute("id");
    // Check if the user id is valid
    if (!userId) {
      return;
    }
    // Prevent the default context menu from appearing
    event.preventDefault();
    if (event.ctrlKey || event.metaKey || event.type === "contextmenu") {
      // Set the selected row and context menu position
      setSelectedRow(userId);
      // Set the context menu position
      setContextMenu({
        mouseX: event.clientX - 2,
        mouseY: event.clientY - 4,
      });
    } else if (event.type === "click") {
      // If it's a left click, navigate to the user details page
      const url = fromClient
        ? `/app/client/${client_id}/user/${userId}`
        : `/app/user/${userId}`;
      history.push(url);
    }
  };

  /**
   * Open new tab with product details
   * @param {boolean} openNewTab - If true, open in new tab, else copy link to clipboard
   * @param {*} openNewTab
   */
  const handleOpenInNewTab = (openNewTab = true) => {
    // Check if selectedRow is valid
    if (selectedRow) {
      // Get the product ID from the selected row
      const userId = selectedRow;
      // Open the new tab with the product details page
      const url = fromClient
        ? `/app/client/${client_id}/user/${userId}`
        : `/app/user/${userId}`;
      // Check if openNewTab is true
      if (openNewTab) {
        // Open the URL in a new tab
        window.open(url, "_blank");
      } else {
        // Copy the URL to the clipboard
        navigator.clipboard
          .writeText(`${process.env.REACT_APP_WEB}${url}`)
          .then(() => {
            setError({
              open: true,
              message: `Link copied to clipboard`,
              severity: "success",
            });
          });
      }
    }
    handleClose();
  };

  return (
    // Container
    <Container
      id="main_container"
      maxWidth="xl"
      style={{ marginTop: "65px" }}
      className={classes.mainContainer}
    >
      {/* Content */}
      <Grid container spacing={3} style={{ padding: "20px" }} id="second_grid">
        {fromClient && client_id != 0 ? (
          // Navigation tabs
          <Grid item xs={12} md={10} id="grid_tabs">
            <NavigationTabs client_id={Number(client_id)} value={"users"} />
          </Grid>
        ) : (
          // Title
          <Grid item xs={12} id="grid_title">
            <Typography variant="h4" gutterBottom>
              Users
            </Typography>
          </Grid>
        )}
        {/* Buttons add - import - export */}
        <Grid item xs={12} sm={12} md={12} lg={12} id="grid_button_add">
          {/* Hidden button on sm and upper screens */}
          <Hidden smUp>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={() => handleClickOpen(null)}
              disabled={client_id == 0 ? true : false}
            >
              + Add User
            </Button>
          </Hidden>
          {/* Hidden button on xs and lower screens */}
          <Hidden xsDown>
            <Button
              variant="contained"
              color="primary"
              onClick={() => handleClickOpen(null)}
              disabled={client_id == 0 ? true : false}
            >
              + Add User
            </Button>
          </Hidden>
          {/* Import button — disabled only while either import or export is
              genuinely running. Re-enables as soon as either reaches DONE;
              accepting the confirmation modal auto-dismisses any finished bar
              still on screen (dismissFinishedQueues, wired into
              createUserExportQueue and ImportUsersModal's onImportConfirmed —
              not here, since opening the modal isn't a commitment to act). */}
          {fromClient && client_id != 0 && (
            <React.Fragment>
              {/* Hidden button on sm and upper screens */}
              <Hidden smUp>
                <Tooltip
                  title={
                    getBlockedReason(importQueue, "Import") ||
                    getBlockedReason(emailQueue, "Export")
                  }
                >
                  <span style={{ display: "block" }}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      onClick={() => ShowimporUser()}
                      style={{ marginTop: "10px" }}
                      disabled={isQueueRunning(importQueue) || isQueueRunning(emailQueue)}
                    >
                      Import
                    </Button>
                  </span>
                </Tooltip>
              </Hidden>
              {/* Hidden button on xs and lower screens */}
              <Hidden xsDown>
                <Tooltip
                  title={
                    getBlockedReason(importQueue, "Import") ||
                    getBlockedReason(emailQueue, "Export")
                  }
                >
                  <span>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => ShowimporUser()}
                      style={{ marginLeft: "10px" }}
                      disabled={isQueueRunning(importQueue) || isQueueRunning(emailQueue)}
                    >
                      Import
                    </Button>
                  </span>
                </Tooltip>
              </Hidden>
            </React.Fragment>
          )}
          {/* Export button — same rule as Import above, mirrored */}
          {fromClient && client_id != 0 && (
            <React.Fragment>
              {/* Hidden button on sm and upper screens */}
              <Hidden smUp>
                <Tooltip
                  title={
                    getBlockedReason(emailQueue, "Export") ||
                    getBlockedReason(importQueue, "Import")
                  }
                >
                  <span style={{ display: "block" }}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      onClick={() => handleClickOpenExportUserModal()}
                      style={{ marginTop: "10px" }}
                      disabled={isQueueRunning(emailQueue) || isQueueRunning(importQueue)}
                    >
                      Export
                    </Button>
                  </span>
                </Tooltip>
              </Hidden>
              {/* Hidden button on xs and lower screens */}
              <Hidden xsDown>
                <Tooltip
                  title={
                    getBlockedReason(emailQueue, "Export") ||
                    getBlockedReason(importQueue, "Import")
                  }
                >
                  <span>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => handleClickOpenExportUserModal()}
                      style={{ marginLeft: "10px" }}
                      disabled={isQueueRunning(emailQueue) || isQueueRunning(importQueue)}
                    >
                      Export
                    </Button>
                  </span>
                </Tooltip>
              </Hidden>
            </React.Fragment>
          )}
          {/**Buttons Modify users*/}
          {Select && fromClient && client_id != 0 && (
            <Fragment>
              {/**Change division categories buttons */}
              <Hidden smUp>
                <Button
                  fullWidth
                  color="primary"
                  onClick={() => {
                    handleModifyUsers();
                  }}
                  style={{ marginLeft: "10px" }}
                >
                  CHANGE DIVISION
                </Button>
              </Hidden>
              <Hidden xsDown>
                <Button
                  color="primary"
                  onClick={() => {
                    handleModifyUsers();
                  }}
                  className={classes.modifyopenbutton}
                >
                  CHANGE DIVISION
                </Button>
              </Hidden>
              <Hidden smUp>
                <PointSchedulerDialog
                  openButtonText="MANAGE POINTS"
                  openButtonVariant="text"
                  openButtonColor="primary"
                  openButtonFullWidth={true}
                  dialogTitle="Manage Points"
                  division_categories={[]}
                  setError={setError}
                  getSchedulePoints={() => {}}
                  client_id={client_id}
                  userIds={[
                    ...usersToModify.map((user) => {
                      return user.id;
                    }),
                  ]}
                />
              </Hidden>
              <Hidden xsDown>
                <PointSchedulerDialog
                  openButtonText="MANAGE POINTS"
                  openButtonVariant="text"
                  openButtonColor="primary"
                  openButtonFullWidth={false}
                  dialogTitle="Manage Points"
                  division_categories={division_categories}
                  setError={setError}
                  getSchedulePoints={() => {}}
                  client_id={client_id}
                  userIds={[
                    ...usersToModify.map((user) => {
                      return user.id;
                    }),
                  ]}
                />
              </Hidden>
              {/**Disable buttons */}
              <Hidden smUp>
                <Button
                  fullWidth
                  color="secondary"
                  onClick={HandleOpenModifyDialog}
                  style={{ marginLeft: "10px" }}
                >
                  DISABLE
                </Button>
              </Hidden>
              {/* Hidden button on xs and lower screens */}
              <Hidden xsDown>
                <Button
                  color="secondary"
                  onClick={HandleOpenModifyDialog}
                  style={{ marginLeft: "10px" }}
                >
                  DISABLE
                </Button>
              </Hidden>
            </Fragment>
          )}
          {/**Export users status */}
          {emailQueue && (
            <>
              <Hidden smUp>
                <span style={{ float: "right", width: "100%" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Typography noWrap style={{ flexGrow: 1 }}>
                      {`Export status: ${emailQueueSteps[activeStep]}`}
                    </Typography>
                    {emailQueue.status === "DONE" && (
                      <Tooltip title="Dismiss now (it will also clear automatically when you start a new action)">
                        <IconButton
                          size="small"
                          style={{ padding: 4 }}
                          aria-label="Dismiss export status"
                          onClick={handleDismissEmailQueue}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>
                  <LinearProgressWithLabel value={progress} />
                </span>
              </Hidden>
              <Hidden xsDown>
                <span style={{ float: "right", width: "320px" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Typography noWrap style={{ flexGrow: 1 }}>
                      {`Export status: ${emailQueueSteps[activeStep]}`}
                    </Typography>
                    {emailQueue.status === "DONE" && (
                      <Tooltip title="Dismiss now (it will also clear automatically when you start a new action)">
                        <IconButton
                          size="small"
                          style={{ padding: 4 }}
                          aria-label="Dismiss export status"
                          onClick={handleDismissEmailQueue}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>
                  <LinearProgressWithLabel value={progress} />
                </span>
              </Hidden>
            </>
          )}
          {/**Import users status */}
          {importQueue && (
            <>
              <Hidden smUp>
                <span style={{ float: "right", width: "100%" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Typography noWrap style={{ flexGrow: 1 }}>
                      {`Import status: ${importQueueSteps[importActiveStep]}`}
                    </Typography>
                    {importQueue.status === "DONE" && (
                      <Tooltip title="Dismiss now (it will also clear automatically when you start a new action)">
                        <IconButton
                          size="small"
                          style={{ padding: 4 }}
                          aria-label="Dismiss import status"
                          onClick={handleDismissImportQueue}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>
                  <LinearProgressWithLabel value={importProgress} />
                </span>
              </Hidden>
              <Hidden xsDown>
                <span style={{ float: "right", width: "320px" }}>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Typography noWrap style={{ flexGrow: 1 }}>
                      {`Import status: ${importQueueSteps[importActiveStep]}`}
                    </Typography>
                    {importQueue.status === "DONE" && (
                      <Tooltip title="Dismiss now (it will also clear automatically when you start a new action)">
                        <IconButton
                          size="small"
                          style={{ padding: 4 }}
                          aria-label="Dismiss import status"
                          onClick={handleDismissImportQueue}
                        >
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>
                  <LinearProgressWithLabel value={importProgress} />
                </span>
              </Hidden>
            </>
          )}
        </Grid>
        {/**Table Skeletor loading */}
        {loading ? (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={9} style={{ padding: "12px" }}>
                  <Skeleton
                    variant="rectangular"
                    height={30}
                    style={{ margin: "3px" }}
                    width={120}
                  />
                </Grid>
                <Grid
                  item
                  xs={3}
                  style={{
                    padding: "12px 25px 12px 12px",
                    marginBottom: "20px",
                  }}
                >
                  {[1, 2, 3, 4].map((row, index) => {
                    return (
                      <Skeleton
                        key={index}
                        variant="rectangular"
                        height={30}
                        style={{ margin: "3px", float: "right" }}
                        width={40}
                      />
                    );
                  })}
                </Grid>
              </Grid>
              <Grid container>
                {[1, 2, 3, 4, 5, 6, 7, 8].map((row, i) => {
                  return (
                    <Grid key={i} container>
                      <Grid item xs={2}>
                        <Skeleton
                          variant="rectangular"
                          height={30}
                          style={{ margin: "3px", marginBottom: "15px" }}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <Skeleton
                          variant="rectangular"
                          height={30}
                          style={{ margin: "3px" }}
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <Skeleton
                          variant="rectangular"
                          height={30}
                          style={{ margin: "3px" }}
                        />
                      </Grid>
                      <Grid item xs={3}>
                        <Skeleton
                          variant="rectangular"
                          height={30}
                          style={{ margin: "3px" }}
                        />
                      </Grid>
                      <Grid item xs={2}>
                        <Skeleton
                          variant="rectangular"
                          height={30}
                          style={{ margin: "3px" }}
                        />
                      </Grid>
                    </Grid>
                  );
                })}
              </Grid>
            </Grid>
          </Grid>
        ) : userList.length < 1 || clientUsers.length < 1 ? (
          <Grid item xs={12}>
            {client_id == 0 ? (
              <Grid item xs={12}>
                <Typography variant="h4" gutterBottom>
                  This user doesn&apos;t have any client, please contact an
                  administrator.
                </Typography>
              </Grid>
            ) : (
              <Typography variant={"h5"}>
                No users for this {fromClient ? " client" : " reseller"}
              </Typography>
            )}
          </Grid>
        ) : (
          <Grid xs={12} sm={12} md={12} lg={12}>
            {/**Client Users Table List */}
            <MuiThemeProvider theme={theme}>
              <div
                onContextMenu={handleContextMenu}
                onClick={handleContextMenu}
              >
                <MUIDataTable
                  data={clientUsers}
                  columns={initialColums}
                  options={options}
                />
              </div>
              {/**Menu - Open new tab */}
              <Menu
                open={contextMenu !== null}
                onClose={handleClose}
                anchorReference="anchorPosition"
                anchorPosition={
                  contextMenu
                    ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                    : undefined
                }
                autoFocus={false}
                disableAutoFocusItem
                disableRestoreFocus
              >
                <MenuItem onClick={handleOpenInNewTab}>
                  Open link in a new tab
                </MenuItem>
                <MenuItem onClick={() => handleOpenInNewTab(false)}>
                  Copy link
                </MenuItem>
              </Menu>
            </MuiThemeProvider>
          </Grid>
        )}
      </Grid>
      {/* Create and update user dialog */}
      <UserDialog
        open={open}
        handleClose={handleClose}
        division_categories={division_categories}
        approval_groups={approval_groups}
        roles={roles}
        formik={formik}
        removeUser={removeUser}
        user_division_categories={user_division_categories}
        addDivisionCategory={addDivisionCategory}
        removeDivisionCategory={removeDivisionCategory}
        fromClient={fromClient}
        saving={saving}
        setCustomer={setCustomer}
        currentClient={currentClient}
        getApprovalGroups={getApprovalGroups}
      />
      {/* Show success or error */}
      <SnackbarMessage
        open={error.open}
        severity={error.severity}
        message={error.message}
        handleClose={handleCloseSnackbar}
      />
      {/*Show Import User Modal */}
      <ImportUsersModal
        open={OpenUserimport}
        handleClose={handleClose}
        getUsers={getUsers}
        setError={setError}
        onImportConfirmed={dismissFinishedQueues}
        onImportQueued={getImportEmailQueueStatus}
        onImportRejected={syncQueueStatuses}
      />
      {/**Show ModifyDivisionsUsersDialog Modal */}
      <ModifyDivisionsUsersDialog
        open={ModifyDivisions}
        handleClose={handleClose}
        usersToModify={usersToModify}
        divisionCategories={division_categories}
        loading={loadingDivisions}
      />
      {/** Show Alert dialog export users */}
      {exportUserOpen && (
        <ExportUsersModal
          open={exportUserOpen}
          handleClose={handleClickOpenExportUserModal}
          client_id={client_id}
        />
      )}
      {/** Open modifu dialog to small screens*/}
      {openModifyDialog && (
        <ModufyDialog
          open={openModifyDialog}
          handleClose={handleClose}
          usersToModify={usersToModify}
          DisableUsers={DisableUsers}
        />
      )}
    </Container>
  );
};

UserList.propTypes = {
  clients: PropTypes.array,
};

export default UserList;
